const STAGING_HOSTNAME = 'staging.truemaple.net';
const AUTH_COOKIE_NAME = 'soapbox_staging_admin_authorized';
const AUTH_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 8;

const cookieNamePrefix = `${AUTH_COOKIE_NAME}=`;

const buildCookieAttributes = () => {
  const attributes = [
    'Path=/',
    'SameSite=Lax',
    `Max-Age=${AUTH_COOKIE_MAX_AGE_SECONDS}`,
  ];

  if (window.location.protocol === 'https:') {
    attributes.push('Secure');
  }

  return attributes.join('; ');
};

export const shouldRequireStagingAdminGate = (): boolean => {
  return window.location.hostname.toLowerCase() === STAGING_HOSTNAME;
};

export const hasStagingAdminAuthorization = (): boolean => {
  const cookies = document.cookie.split(';').map((cookie) => cookie.trim());
  return cookies.some((cookie) => cookie.startsWith(cookieNamePrefix));
};

export const setStagingAdminAuthorization = (): void => {
  document.cookie = `${AUTH_COOKIE_NAME}=1; ${buildCookieAttributes()}`;
};

export const clearStagingAdminAuthorization = (): void => {
  document.cookie = `${AUTH_COOKIE_NAME}=; Path=/; Max-Age=0; SameSite=Lax`;
};
